itsoftApp.createModule("headerFixed", function() {
    itsoftApp.loadScript("assets/scripts/headroom/headroom.min.js", function () {
        var header = document.querySelector(".l-header");
        var pageWrapper = document.querySelector(".l-wrapper");
        var headerObj;
        var headerHeight;

        var setPagePadding = function () {
            pageWrapper.style.paddingTop = itsoftApp.commonVars.headerHeight;
        }

        var updateHeaderHeight = function () {
            headerHeight = itsoftApp.utils.getHeaderHeight();
        }

        headerObj = new Headroom(header);

        itsoftApp.modules.windowResize.addEvent(updateHeaderHeight);
        headerObj.init();
    });
});
